import { Box } from '@mui/material';
import { toColonTimeFromMs } from 'services/helpers/time';
import useWavesurferContext from 'services/hooks/wavesurfer';
import { MobileDuration, Title, TitleWrapper } from './styled';

const TitleSection = () => {
  const { song, currentTime } = useWavesurferContext();

  if (!song) {
    return null;
  }

  return (
    <TitleWrapper>
      <Box>
        <Title>{song.title}</Title>
        <MobileDuration variant="body1">
          {toColonTimeFromMs(currentTime * 1000)}
        </MobileDuration>
      </Box>
    </TitleWrapper>
  );
};

export default TitleSection;
